import axios from 'axios';
import { getEnvironmentVariable } from '../utils';
import { getAuthTokens } from '../providers/authTokenProvider';

const BASE_URL = getEnvironmentVariable('REACT_APP_API_URL');

const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

const platformURL = getEnvironmentVariable('REACT_APP_PLATFORM_URL');

const endpointsWithoutToken: string[] = [
    platformURL + '/JWT/react/login',
    platformURL + '/JWT/session/login',
    platformURL + '/JWT/validate',
];

const reactTokenEndpoints: string[] = [
    '/decisions/list/popular',
    '/categories',
    '/decisions/list/trend',
    '/decisions/list/bycategory',
    '/pages/list',
    '/pages/detail',
];

const isProtectedEndpoint = (endpoint: string | undefined): boolean => {
    if (!endpoint) {
        return false;
    }

    return !endpointsWithoutToken.some(publicURL => endpoint.startsWith(publicURL));
};

const isReactEndpoint = (endpoint: string | undefined): boolean => {
    if (!endpoint) {
        return false;
    }

    return reactTokenEndpoints.some(template => endpoint.startsWith(template));
};

export const getTokenForEndpoint = (endpoint: string | undefined): {
    token: string;
    authHeader: 'AuthorizationUser' | 'AuthorizationReact';
} => {
    const tokens = getAuthTokens();

    if (isReactEndpoint(endpoint)) {
        return {
            token: tokens.reactToken,
            authHeader: 'AuthorizationReact',
        };
    }

    return {
        token: tokens.sessionToken,
        authHeader: 'AuthorizationUser',
    };
};

axiosInstance.interceptors.request.use(
    (config) => {
        if (!isProtectedEndpoint(config.url)) {
            return config;
        }

        const { authHeader, token } = getTokenForEndpoint(config.url);

        config.headers[authHeader] = token;
        // console.log('auth', { authHeader, token });
        // config.headers['api-token'] = '59bcb0fad3f8354ec67d96001a2202aac14e4b8b';

        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

export default axiosInstance;
